import { createTrackingUtils } from "../index";
import { UIBrandedFareInfo } from "@flights/types";
import { getFeaturesToRender } from "branded-fares/utils/features";

const utils = createTrackingUtils({
  name: "flights_apex_web_clarify_flex_features",
  stages: {
    main: 1,
    mdot: 2,
    ddot: 3,
    branded_fares: 4,
    search_results: 5,
    check_and_pay: 6
  },
  goals: {},
  defaultStage: 1
});

type WithBrandedFareInfo = {
  brandedFareInfo: UIBrandedFareInfo;
};

const trackStages = (
  isMobile: boolean,
  page: "branded_fares" | "search_results" | "check_and_pay",
  brandedFareOffers: WithBrandedFareInfo[]
) => {
  if (!brandedFareOffers.some(({ brandedFareInfo }) => hasFlexibility(brandedFareInfo))) return;

  utils.stages.main();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (page === "branded_fares") utils.stages.branded_fares();
  if (page === "search_results") utils.stages.search_results();
  if (page === "check_and_pay") utils.stages.check_and_pay();
};

const hasFlexibility = (brandedFareInfo: UIBrandedFareInfo) => {
  const { includedFeatures, nonIncludedFeatures } = getFeaturesToRender(brandedFareInfo);
  return [...includedFeatures, ...nonIncludedFeatures].some((feature) => feature.group === "FLEXIBILITY");
};

export default { ...utils, trackStages };
